import Link from 'components/Link/Link'
import styled, { css } from 'styled-components'
import { breakpoint, breakpointMax, theme } from 'utils/style'

const linkStyle = css`
  display: inline-block;
  color: ${theme('colors.black')};
  text-decoration: none;

  &:hover {
    color: ${theme('colors.hover.secondary')};
  }

  ${breakpointMax('l')`
    padding-bottom: ${theme('spaces.m')};
    padding-top: ${theme('spaces.m')};
  `}

  ${breakpoint('l')`
    font-weight: bold;
    font-size: ${theme('fonts.size.s')};
    padding: ${theme('spaces.m')};
  `}

  ${breakpoint('xl')`
    padding-left: ${theme('spaces.l')};
    padding-right: ${theme('spaces.l')};
    font-size: ${theme('fonts.size.base')};
  `}

  &.qs-linkMenu--toggle {
    position: relative;
    padding-right: calc(${theme('spaces.m')} + 1.4rem);

    ${breakpoint('xl')`
      padding-right: calc(${theme('spaces.l')} + 1.4rem);
    `}

    &::after {
      position: absolute;
      right: 1.4rem;
      top: 50%;
      margin-top: -0.2rem;
      margin-left: -0.2rem;
      width: 0;
      height: 0;
      border-left: 0.4rem solid transparent;
      border-right: 0.4rem solid transparent;
      border-top: 0.4rem solid ${theme('colors.black')};
      content: '';

      ${breakpoint('xl')`
        right: 2.05rem;
     `}
    }

    &:hover::after {
      border-top-color: ${theme('colors.primary')};
    }
  }

  &.qs-linkMenu-pro {
    span:first-child {
      font-weight: normal;
    }
  }
`

const MenuLink = styled(Link)`
  ${linkStyle}
`

export default MenuLink
